export const formatCurrency = (value: number) => {
  if (!value) return '$0.00'

  const dollar = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  })

  return dollar.format(value)
}
